export const baseUrl = `${process.env.REACT_APP_API_HOST}`;
export const ssoUrl = `${process.env.REACT_APP_SSO_HOST}`;

// External login URL used for authenticating GAMBoD users via GSA website.
// Successful login redirects back to the GAMBoD staging dashboard.

export const externalLoginUrl = `${process.env.REACT_APP_SSO_REDIRECT_URL}`;
/*
export const externalLoginUrl =
  "https://gsacom.com/login/?redirect=https%3A%2F%2Fstaging.gambod.gsacom.com%2Fdashboard";
 */


export const prepareHeaders = (headers: Headers) => {
  const gambod = localStorage.getItem("gambod");
  if (gambod) {
    const state = JSON.parse(gambod);

    headers.set("Authorization", `Bearer ${state.token}`);
  }

  return headers;
};
